<template>
  <div>
    <InvestmentManagerDetailMobile
      v-if="isMobile"
      :other-links="otherLinks"
      :page-description="pageDescription"
      :im-code="investmentManager"
      :title="name"
      :key-person="keyPerson"
      :address="address"
    />
    <InvestmentManagerDetailDesktop
      v-else
      :other-links="otherLinks"
      :page-description="pageDescription"
      :im-code="investmentManager"
      :title="name"
      :key-person="keyPerson"
      :address="address"
      :breadcrumb-links="breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  generateOtherLinks,
  getInvestmentManagerObject,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import InvestmentManagerDetailMobile from '../../components/mobile/investment_manager/InvestmentManagerDetail';
import InvestmentManagerDetailDesktop from '../../components/desktop/investment_manager/InvestmentManagerDetail';

export default {
  name: 'InvestmentManagerDetailPage',
  metaInfo() {
    return {
      title: this.investmentManagerObject.meta_title,
      meta: [
        { name: 'description', content: this.investmentManagerObject.meta_desc },
        { name: 'keyword', content: this.investmentManagerObject.meta_keyword },
      ],
    };
  },
  components: {
    InvestmentManagerDetailMobile,
    InvestmentManagerDetailDesktop,
  },
  mixins: [isMobile],
  props: {
    detail: {
      type: String,
      default: null,
    },
  },
  computed: {
    otherLinks() {
      return generateOtherLinks(this.page, CONSTANT.INVESTMENT_MANAGER_KEY);
    },
    pageDescription() {
      return this.investmentManagerObject.about;
    },
    keyPerson() {
      return this.investmentManagerObject.keyPerson;
    },
    address() {
      return this.investmentManagerObject.address;
    },
    investmentManager() {
      return this.investmentManagerObject.mi_code;
    },
    investmentManagerObject() {
      return getInvestmentManagerObject(this.detail);
    },
    page() {
      return this.investmentManagerObject.key;
    },
    name() {
      return this.investmentManagerObject.name;
    },
    breadcrumbLinks() {
      return generateBreadcrumbLinks(CONSTANT.INVESTMENT_MANAGER_KEY, this.page);
    },
  },
};
</script>
